/* eslint-disable no-underscore-dangle */
export const initMetaPixel = (pixelId) => {
  if (!pixelId || window.fbq) return;

  const fbq = (...args) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  };

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);

  window.fbq = fbq;
  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
};

export const trackMetaPageView = () => {
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const trackMetaEvent = (eventName, params = {}) => {
  if (window.fbq) {
    window.fbq('track', eventName, params);
  }
};
